'use strict';

var $ = require('dibs-jquery-shim');
var _ = require('underscore');

var deferredHelpers = module.exports = {
    /**
     * Returns a promise that resolves after a delay
     * @param timeout in ms
     * @returns Promise
     */
    wait: function (timeout) {
        return $.Deferred(function (dfd) {
            setTimeout(dfd.resolve, timeout);
        }).promise();
    },
    /**
     * Wraps a promise in a deferred so we can cancel it
     * @private
     */
    wrapDeferred: function (jqXHR) {
        var dfd = new $.Deferred();
        jqXHR.then(dfd.resolve, dfd.reject);
        return dfd;
    },
    /**
     * Cancels an unresolved deferred after timeout has elapsed
     * @param dfd
     * @param timeout
     */
    cancelAfter: function (dfd, timeout) {
        var id = setTimeout(function () {
            if (dfd.state() === 'pending') {
                dfd.reject({status: 'timeout'});
            }
        }, timeout);

        dfd.done(function () {
            clearTimeout(id);
        });
    },
    /**
     * Run the provided function over and over until it works!
     * @param fn a function that returns a promise
     * @param maxTries number of times to retry
     * @param {Function} [condition] only retry if condition is true
     */


    retry: function (fn, maxTries, condition) {
        return fn().then(null, function (result) {
            if (maxTries > 1) {
                if (_.isFunction(condition) && !condition(result)) {
                    return result;
                }
                return deferredHelpers.retry(fn, maxTries - 1, condition);
            }
            return result;
        });
    },
    /**
     * Retry the jqXhr returning function over and over until it's not a 500
     * @param fn
     * @param maxTries
     * @returns {*}
     */
    retry500: function (fn, maxTries) {
        return deferredHelpers.retry(fn, maxTries, function (jq) {
            return jq.status >= 500;
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/bunsen/helpers/deferredHelpers.js
// module id = 168
// module chunks = 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54 55 56